/* The Broward Design Center — collection pagination.
   One code path serves both theme modes:
     • load_more       → an explicit .js-load-more button fetches the next page on click.
     • infinite_scroll → an IntersectionObserver auto-loads as the sentinel nears view,
                         so a shopper never has to click through page after page.
   A single in-flight lock plus a single, reused observer prevent the duplicate
   fetches the previous implementation was prone to (it created a fresh observer on
   every load). Newly appended cards get their color swatches rebuilt and wishlist
   hearts rebound (via the theme's `bdc:cards:loaded` event), and each load is
   announced through an aria-live region for assistive tech. When JavaScript or
   IntersectionObserver is unavailable the server-rendered pagination links inside
   `.js-hidden` remain the fallback — nothing here is required to browse. */
(function () {
  var grid = document.querySelector('.load-more-grid');
  if (!grid) return;

  var button = document.querySelector('.js-load-more');
  var sentinel = document.querySelector('.js-infinite-scroll');
  if (!button && !sentinel) return; // no pagination on this page (small collection)

  var isLoading = false;
  var observer = null;
  var live = null;

  function state() {
    var totalEl = document.querySelector('[data-total-pages]');
    var currentEl = document.querySelector('[data-current-page]');
    var nextEl = document.querySelector('[data-next-url]');
    return {
      total: totalEl ? parseInt(totalEl.value, 10) || 1 : 1,
      current: currentEl ? parseInt(currentEl.value, 10) || 1 : 1,
      nextUrl: nextEl ? nextEl.value : '',
      currentEl: currentEl,
      nextEl: nextEl
    };
  }

  function announce(msg) {
    if (!live) {
      live = document.createElement('p');
      live.className = 'visually-hidden';
      live.setAttribute('aria-live', 'polite');
      live.setAttribute('role', 'status');
      grid.parentNode.insertBefore(live, grid.nextSibling);
    }
    live.textContent = msg;
  }

  function stop() {
    if (observer) { observer.disconnect(); observer = null; }
    if (button) button.remove();
    if (sentinel) sentinel.remove();
  }

  function reinitCards() {
    if (typeof colorSwatches === 'function') {
      try { colorSwatches(); } catch (e) {}
    }
    // Rebind wishlist hearts (and any other card-level enhancers) on the new cards.
    document.dispatchEvent(new Event('bdc:cards:loaded'));
  }

  function load() {
    if (isLoading) return;
    var s = state();
    if (s.current >= s.total || !s.nextUrl) { stop(); return; }

    isLoading = true;
    if (button) { button.setAttribute('disabled', ''); button.classList.add('loading'); }

    var targetPage = s.current + 1;
    var url = s.nextUrl.replace(/([?&]page=)[0-9]+/, '$1' + targetPage);
    if (url === s.nextUrl && !/[?&]page=/.test(url)) {
      url += (url.indexOf('?') === -1 ? '?' : '&') + 'page=' + targetPage;
    }

    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var incoming = doc.querySelector('.load-more-grid');
        if (incoming && incoming.children.length) {
          var frag = document.createDocumentFragment();
          Array.prototype.slice.call(incoming.children).forEach(function (node) {
            frag.appendChild(document.importNode(node, true));
          });
          grid.appendChild(frag);
          reinitCards();
        }
        // Advance the shared state so the next intersection/click loads the page after.
        if (s.currentEl) s.currentEl.value = targetPage;
        if (s.nextEl) s.nextEl.value = url;
        announce('Showing page ' + targetPage + ' of ' + s.total + '.');
      })
      .catch(function () {
        announce('Could not load more products. Please try again.');
      })
      .then(function () {
        isLoading = false;
        if (button) { button.removeAttribute('disabled'); button.classList.remove('loading'); }
        var after = state();
        if (after.current >= after.total) stop();
      });
  }

  if (button) {
    button.addEventListener('click', function (e) { e.preventDefault(); load(); });
  }

  if (sentinel && 'IntersectionObserver' in window) {
    // One observer, kept for the page's life; rootMargin pre-loads before the
    // shopper reaches the bottom so scrolling feels continuous.
    observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) { load(); break; }
      }
    }, { rootMargin: '800px 0px' });
    observer.observe(sentinel);
  }
})();
